module.exports = __webpack_public_path__ + "img/minimize.2d015519.svg";